// extracted by mini-css-extract-plugin
export default {"container":"Login_container__kSGIq","loginBox":"Login_loginBox__D75Jl","tech":"Login_tech__tGfme","cameraBox":"Login_cameraBox__tVEb6"};